import StepperOption from './StepperOption'

import { Container } from './styles'

const defaultSteps = ['Mês', 'Comissão', 'Valores', 'Meta', 'Revisão']

/** @param {any} props */
export const GoalWizardStepper = ({
  steps = defaultSteps,
  activeStep,
  progressStep,
  onStepClick
}) => {
  const progressRatio = progressStep / (steps.length - 1)

  return (
    <Container>
      <div className='stepper-bar'>
        <div
          style={{ transform: `translateX(${progressRatio * 100}%)` }}
          className='progress-stepper-circle-container'
        >
          <div className='progress-stepper-circle' />
        </div>
        <div
          style={{ transform: `scaleX(${progressRatio})` }}
          className='progress-stepper-bar'
        />
      </div>

      <div className='stepper-options'>
        {steps.map((step, index) => (
          <StepperOption
            key={step}
            active={activeStep === index}
            progressTitle={step}
            conditionToCompleted={progressStep >= index}
            onClick={() => onStepClick(index)}
          />
        ))}
      </div>
    </Container>
  )
}

export default GoalWizardStepper
